export default __webpack_public_path__ + "static/media/angle.afe5c2b6.svg";